import type {UpdateMaterialFormPayload} from "./update-material.schema";

import {updateMaterial} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../material-keys";

export function updateMaterialMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: materialMutationKeys.updateMaterial,
    mutationFn: (payload: UpdateMaterialFormPayload) => updateMaterial(id, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: materialKeys.detail(id)}),
        client.invalidateQueries({queryKey: materialKeys.lists()}),
      ]);
    },
  });
}
